import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";
import SectionHeading from "@/components/base/SectionHeading";

export default function FeaturedSection() {
  const featured = articles.filter((a) => a.featured);
  const others = articles.filter((a) => !a.featured).slice(0, 3);

  return (
    <section id="featured" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-100/60">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <SectionHeading
          eyebrow="编辑精选"
          title="值得慢慢看完的深度内容"
          desc="不只是搬运热搜，我们把事件拆开、把脉络讲清，让你吃完瓜还能留下点判断力。"
        />
        <Link
          to="/hot"
          className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
        >
          浏览全部内容
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {featured.map((article, index) => (
          <div key={article.slug} className={index === 0 ? "md:col-span-2" : ""}>
            {index === 0 ? (
              <ArticleCard article={article} layout="horizontal" />
            ) : (
              <ArticleCard article={article} />
            )}
          </div>
        ))}
      </div>

      <div className="mt-8 md:mt-12">
        <h3 className="text-lg font-semibold text-foreground-950 mb-5 flex items-center gap-2">
          <i className="ri-bookmark-3-line w-5 h-5 flex items-center justify-center text-accent-600"></i>
          更多人气整理
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {others.map((article) => (
            <ArticleCard key={article.slug} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}